<ng-container *ngIf="!user.hasTinsAwaitingApproval">
  <div
    *ngIf="!user?.restricted; else RestrictedView"
    data-test="wam-table-status-registered"
    class="cg-color-success cg-bold"
  >
    Registered
  </div>
  <div *ngIf="hasChcpAcccess(user)" class="cg-margin-top-xs">
    CignaforHCP.com
  </div>
  <div *ngIf="hasEvernorthAcccess(user)" class="cg-margin-top-xs">
    Provider.Evernorth.com
  </div>
</ng-container>

<ng-container *ngIf="user.hasTinsAwaitingApproval">
  <div
    *ngIf="!user?.restricted; else RestrictedView"
    class="cg-color-warn"
    data-test="wam-table-status-awaiting"
  >
    Awaiting approval
  </div>
  <div class="cg-margin-top-xs">
    (Requested approval on {{ user.requestedDate | date : 'shortDate' }})
  </div>
  <div *ngIf="hasChcpAcccess(user)" class="cg-margin-top-xs">
    CignaforHCP.com
  </div>
  <div *ngIf="hasEvernorthAcccess(user)" class="cg-margin-top-xs">
    Provider.Evernorth.com
  </div>
</ng-container>

<ng-template #RestrictedView>
  <div class="cg-color-severe-warn" data-test="wam-table-status-access-alert">
    Access alert
    <cigna-popover
      [content]="accessAlertMsg"
      placement="right"
      close="Close"
      underlineStyle="no-underline"
      [areaLabelText]="'ACCESS ALERT'"
      ><cigna-icon
        type="question-circle"
        class="cg-icon-xs cg-margin-left-sm"
      ></cigna-icon
    ></cigna-popover>
  </div>
</ng-template>

<ng-template #accessAlertMsg>
  <div>
    There is an issue with the email address. If you still need to provide
    access to this user, please contact Customer Service at
    <span *ngIf="appContext === 'chcp'">1.800.981.9114.</span
    ><span *ngIf="appContext === 'evernorth'">1.888.736.7499.</span>
  </div>
</ng-template>

<div class="cg-margin-top-lg">
  <button
    *ngIf="canShowRemove(user)"
    cignaButton="link"
    style="padding: 0"
    data-test="wam-table-remove-access"
    (click)="removeAccessForUser.emit(user)"
  >
    Remove Access
  </button>
  <span *ngIf="canShowRemove(user) && canShowReset(user) && !user?.restricted">
    |
  </span>
  <button
    *ngIf="canShowReset(user) && !user?.restricted"
    cignaButton="link"
    style="padding: 0"
    data-test="wam-table-reset-password"
    (click)="resetPasswordForUser.emit(user)"
  >
    Reset password
  </button>
</div>
